module.exports = __webpack_public_path__ + "img/door-assembly-search.915a5895.png";